export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoic210cGVyZm9ybWFuY2VzIiwiYSI6ImNsZGU3OGdvOTBhcXgzbm8xdDJleDhzaTgifQ.0PYF4sqTqRNV_63QkigbBg'

export const MARKER_SIZE = 48
